import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ChapterModerationRow from "./Admin/ChapterModerationRow";
import {
  getPendingContentParts,
  type PendingContentPartItem,
} from "../api/adminContentApi";

const PAGE_SIZE = 10;

export default function AdminChaptersModeration() {
  const [items, setItems] = useState<PendingContentPartItem[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const fetchPending = async () => {
      setInitialLoading(true);
      const page = await getPendingContentParts(0, PAGE_SIZE);
      setItems(page.items);
      setTotalCount(page.totalCount);
      setInitialLoading(false);
    };

    fetchPending().catch((error) => {
      console.error("pending load failed", error);
      Swal.fire("Hata", "Bekleyen bölümler yüklenemedi.", "error");
      setItems([]);
      setTotalCount(0);
      setInitialLoading(false);
    });
  }, [refreshKey]);

  const loadMore = async () => {
    if (loadingMore || items.length >= totalCount) {
      return;
    }

    setLoadingMore(true);
    try {
      const page = await getPendingContentParts(items.length, PAGE_SIZE);
      setItems((prev) => [...prev, ...page.items]);
      setTotalCount(page.totalCount);
    } catch (error) {
      console.error("load more failed", error);
      Swal.fire("Hata", "Daha fazla kayıt yüklenemedi.", "error");
    } finally {
      setLoadingMore(false);
    }
  };

  const handleChanged = () => {
    setRefreshKey((key) => key + 1);
  };

  return (
    <div className="rounded bg-white p-4 shadow">
      <h2 className="mb-2 text-lg font-semibold">Bölüm Moderasyonu</h2>
      <p className="mb-4 text-xs text-gray-500">
        Bekleyen gönderileri incele, önizleme durumunu ayarla, onayla veya reddet. Her serinin ilk bölümü ücretsiz önizleme olarak kalmalıdır.
      </p>

      {initialLoading && <div className="text-sm text-gray-500">Bekleyen bölümler yükleniyor...</div>}

      {!initialLoading && items.length === 0 && (
        <div className="text-sm text-gray-500">Onay bekleyen bölüm yok.</div>
      )}

      {!initialLoading && items.length > 0 && (
        <div className="divide-y divide-gray-200">
          {items.map((item) => (
            <ChapterModerationRow
              key={item.id}
              partId={item.id}
              partTitle={item.partTitle}
              contentTitle={item.contentTitle}
              authorName={item.authorName}
              createdAt={item.createdAt}
              initialIsFreePreview={item.isFreePreview}
              initialIsPremium={item.isPremium}
              onChanged={handleChanged}
            />
          ))}
        </div>
      )}

      {!initialLoading && items.length < totalCount && (
        <div className="mt-4 flex justify-center">
          <button
            onClick={loadMore}
            disabled={loadingMore}
            className="rounded bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {loadingMore ? "Loading..." : "Load more"}
          </button>
        </div>
      )}
    </div>
  );
}
